class cursorView {
  _cursor;
  _mouseX = 0;
  _mouseY = 0;
  _cursorX = 0;
  _cursorY = 0;

  addHandlerCursorListeners() {
    // Only use the custom cursor on devices with a mouse/trackpad.
    if (!window.matchMedia("(pointer: fine)").matches) return;

    // Create the cursor square via JavaScript and append it to the body.
    this._cursor = document.createElement("div");
    this._cursor.className = "custom-cursor";
    document.body.append(this._cursor);

    // Update the target coordinates every time the mouse moves.
    // The visual cursor doesn't jump there immediately: it eases in via _animate().
    window.addEventListener("mousemove", this._handleMouseMove.bind(this));

    // On click, add a temporary class for the "pressed" state.
    window.addEventListener("mousedown", () =>
      this._cursor.classList.add("is-pressed"),
    );
    window.addEventListener("mouseup", () =>
      this._cursor.classList.remove("is-pressed"),
    );

    // If the mouse leaves the window, hide the custom cursor.
    document.addEventListener("mouseleave", () =>
      this._cursor.classList.remove("is-visible"),
    );

    // Start the loop that actually moves the cursor.
    this._animate();
  }

  _handleMouseMove(event) {
    // These are the real mouse coordinates.
    // They are the point the custom cursor needs to reach.
    this._mouseX = event.clientX;
    this._mouseY = event.clientY;
    this._cursor.classList.add("is-visible");
    this._handleHover(event);
  }

  _handleHover(event) {
    //If target is not a DOM el
    if (!(event.target instanceof Element)) return;

    const isInteractive = event.target?.closest(
      "a, button, input, textarea, select, label, [role='button']",
    );

    //When hovering on a preview , cursor is hided
    const isIframe = event.target.classList.contains("projects__preview");

    isIframe
      ? this._cursor.classList.remove("is-visible")
      : this._cursor.classList.add("is-visible");

    // If hovering over an interactive element, enlarge the square.
    this._cursor.classList.toggle("is-hovering", Boolean(isInteractive));
  }

  _animate() {
    // Manual easing: each frame the cursor only covers part of the distance
    // to the real mouse position. The higher this factor, the more reactive the cursor.
    this._cursorX += (this._mouseX - this._cursorX) * 0.9;
    this._cursorY += (this._mouseY - this._cursorY) * 0.9;

    // translate3d moves the cursor, translate(-50%, -50%) centers it on the mouse.
    this._cursor.style.transform = `translate3d(${this._cursorX}px, ${this._cursorY}px, 0) translate(-50%, -50%)`;

    // requestAnimationFrame calls _animate() again before the next frame,
    // creating a smooth loop synced with the screen refresh rate.
    requestAnimationFrame(this._animate.bind(this));
  }
}

export default new cursorView();
